import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=8c4cc0e6&scoped=true&"
import script from "./Registration.vue?vue&type=script&lang=ts&"
export * from "./Registration.vue?vue&type=script&lang=ts&"
import style0 from "./Registration.vue?vue&type=style&index=0&id=8c4cc0e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4cc0e6",
  null
  
)

export default component.exports